import './Musicas.css'
import tracks from './data.js'
import Titulo from '../../components/Título/Titulo.jsx';

const { spotifyTracks , youtubeTracks } = tracks

function Musicas({backgroundImage}) {
  return (
    <>
      <Titulo title='Músicas' backgroundImage={backgroundImage} position='right 35%'></Titulo>
      <div className="music-page">
          <Section className={"sptf-list"} title={"Spotify"}>
            {spotifyTracks.map(track => 
              <Player key={track.id} track={track} className='sptf-frame'/>
            )}
          </Section>
          <Section  className={"yt-list"}  title={"Youtube"}>
            {youtubeTracks.map(track => 
                <Player key={track.id} track={track} className='yt-frame'/>
              )}          
          </Section>
          </div>
    </>
  );
}

function Section({title, children, className}) {
  return (
    <section className={className}>
      <h2 className='section-title'> {title}</h2>
      {children}
    </section>)
}

export default Musicas

function Player({ track , className }){
  return(
    
      <iframe  
        className= {className} 
        src={track.src} 
        title={track.title} 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        referrerPolicy="strict-origin-when-cross-origin" 
        allowFullScreen 
        loading="lazy"/>
    
  )
}
